/* eslint-disable no-case-declarations */
import { RouterName } from "@/models/common";
import { PayStatuses } from "@/models/payment";
import {
  AppointmentTypes,
  IRequestCardInfo,
  IRequestInfoParams,
  RequestKindTypes,
  RequestStatuses,
  ResponseStatuses,
} from "@/models/request";
import DateFormat from "@/utils/date-format";

const isPaySupport = process.env.VUE_APP_IS_PAID === "true" || false;

const RequestInfo = (item: IRequestInfoParams, t: any, onCancel: () => void) => {
  const val: IRequestCardInfo = {
    state: "",
    message: "",
    style: "",
    buttons: [] as Array<any>,
  };

  const cancel = {
    label: item.PayStatus === PayStatuses.PAID ? t("cancel payment and reservation") : t("cancel"),
    type: "button",
    func: onCancel,
    style: "-default",
  };
  const path = {
    //수정
    edit: () => {
      return {
        name:
          item.RequestKind === RequestKindTypes.OnlineCare
            ? RouterName.ONLINE_CARE_REQUEST_EDIT
            : RouterName.SECOND_OPINION_REQUEST_EDIT,
        params: { id: item.RequestKey },
      };
    },

    //회신
    response: () => {
      return {
        name:
          item.RequestKind === RequestKindTypes.OnlineCare
            ? RouterName.ONLINE_CARE_RESPONSE
            : RouterName.SECOND_OPINION_RESPONSE,
        params: { id: item.RequestKey },
      };
    },
    //화상진료
    video: () => {
      return {
        name: RouterName.ONLINE_CARE_VIDEO,
        params: { id: item.RequestKey },
      };
    },
    //처방전
    filePX: () => {
      return {
        name: RouterName.ONLINE_CARE_PX,
        params: { id: item.RequestKey },
      };
    },
    //결제
    checkout: () => {
      return {
        name: RouterName.ORDER_CHECKOUT,
        params: { id: item.RequestKey },
      };
    },
  };
  switch (item.RequestStatus) {
    case RequestStatuses.Requested: //취소 수정 가능
      item.RequestKind === RequestKindTypes.OnlineCare
        ? !!item.RequestType && item.RequestType > 0
          ? ((val.state = t("RequestedQuick")), (val.message = t("request quick reservation")))
          : // : ((val.state = t('Requested')), (val.message = t('confirmed within one hour on average')))
            ((val.state = t("Requested")), (val.message = ""))
        : ((val.state = t("ForOpinion")),
          (val.message = t("after payment is confirmed, completed.")));
      val.style = "-pelorous -medium";
      val.buttons = new Array();
      val.buttons.push(cancel);
      val.buttons.push({
        label: t("edit"),
        type: "link",
        path: path.edit,
        style: "-default",
      });
      break;

    case RequestStatuses.Scheduled:
      val.buttons?.push(cancel);
      if (isPaySupport && (!item.PayStatus || item.PayStatus !== PayStatuses.PAID)) {
        val.state = t("PayReady");
        val.message = t("paid then completed");
        val.style = "-pelorous";
        val.buttons?.push({
          label: t("pay"),
          type: "link",
          path: path.checkout,
          style: "-pelorous",
        });
      } else {
        item.RequestKind === RequestKindTypes.OnlineCare
          ? ((val.state = t("Scheduled")),
            (val.message =
              "D-" + DateFormat.durationDate(item.ScheduledDateTime?.valueOf() ?? "").toString()),
            item.AppointmentType === AppointmentTypes.Telemedicine
              ? val.buttons?.push({
                  label: t("video chat"),
                  type: "link",
                  path: path.video,
                  style: "-royalBlue",
                })
              : null)
          : ((val.message = t("take average one week")), (val.state = t("check payment")));

        val.style =
          item.RequestKind === RequestKindTypes.OnlineCare
            ? "-royalBlue -bold"
            : "-royalBlue -medium";
      }
      break;

    case RequestStatuses.Completed: //회신, 온라인케어는 처방전 확인
      val.buttons?.push({
        label: t("response"),
        type: "link",
        path: path.response,
        style: "-royalBlue",
      });
      val.message = "";
      item.ResponseStatus === ResponseStatuses.Refused
        ? ((val.state = t("Refused")), (val.style = "-brinkPink"))
        : ((val.state = t("Completed")), (val.style = "-royalBlue"));

      const regFileCount = Number.parseInt(item.RegFileCount ? item.RegFileCount.valueOf() : "0");
      const reguserFileCount = Number.parseInt(
        item.RegUserFileCount ? item.RegUserFileCount.valueOf() : "0",
      );
      const preFileCount = item.PreFileCount;

      if (regFileCount - reguserFileCount > 0 || !!preFileCount) {
        val.buttons?.push({
          label: t("check prescription"),
          type: "link",
          path: path.filePX,
          style: "-waikawaGrey",
        });
      }

      break;

    case RequestStatuses.Canceled:
      val.state = t("Canceled");
      val.style = "-brinkPink";
      break;
  }

  return val;
};

export default RequestInfo;
